import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60, // 1 minute default stale time
            refetchOnWindowFocus: true,
            retry: 1,
        },
    },
});
